import { useParams } from "react-router-dom";

import { useGetAllRFQQuery } from "../../store/apiSlices/adminApi";

import { RFQCard } from "../../components/Admin/CustomerRFQsDetails/RFQCard";

export default function CustomerQuotesDetails() {
  const { uid, id } = useParams();
  const { data: rfqs, isLoading } = useGetAllRFQQuery({ uid: Number(uid) });

  const quote = rfqs?.find(
    (el) => el?.id === Number(id) || el?.quotes_id === id,
  );

  if (isLoading)
    return (
      <div className="p-10 text-center text-gray-500 text-sm">
        Loading company details...
      </div>
    );

  if (!quote)
    return (
      <div className="p-10 text-center text-gray-500 text-sm">
        No quote found.
      </div>
    );

  return (
    <section className="bg-white shadow-sm rounded-lg p-6 space-y-6 border border-gray-200">
      <h3 className="text-lg font-medium text-blue-700 capitalize">
        Logistics Quotes
      </h3>

      <RFQCard key={quote.id} quote={quote}>
        <RFQCard.Header />

        <RFQCard.SubInfo />

        <RFQCard.Meta>
          {/* {quote.loading_date && (
            <span>
              <span className="font-medium text-gray-600">Loading:</span>{" "}
              {quote.loading_date}
            </span>
          )} */}

          {quote.pickup_date && (
            <span>
              <span className="font-medium text-gray-600">Pickup:</span>{" "}
              {quote.pickup_date}
            </span>
          )}

          {quote.incoterm && (
            <span className="px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 font-medium">
              {quote.incoterm}
            </span>
          )}

          {quote.goods_category && (
            <span className="truncate max-w-full">
              <span className="font-medium text-gray-600">Goods:</span>{" "}
              {quote.goods_category}
            </span>
          )}
        </RFQCard.Meta>

        <RFQCard.Footer />

        <RFQCard.Actions />
      </RFQCard>
    </section>
  );
}
